import React, { Component } from "react";
import axios from "axios";
import Conf from "./Conf";

class Auth extends Component {
  GetURLParameter(sParam) {
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split("&");
    for (var i = 0; i < sURLVariables.length; i++) {
      var sParameterName = sURLVariables[i].split("=");
      if (sParameterName[0] === sParam) {
        return sParameterName[1];
      } else {
        return null;
      }
    }
  }
  componentDidMount() {
    var ref = this.GetURLParameter("ref");
    if (ref) {
      console.log(ref);
      axios
        .get(Conf.signinURL + "token/" + ref, {
          headers: { "X-Requested-With": "profile" },
        })
        .then((res) => {
          console.log(res.data);
          if (res.data.token) {
            axios
              .get(Conf.signinURL + "me", {
                headers: {
                  authorization: res.data.token,
                  "X-Requested-With": "profile",
                },
              })
              .then((res2) => {
                axios
                  .post(Conf.backendURL + "oauth/signin", {
                    profile: res2.data.profile,
                  })
                  .then((res3) => {
                    console.log(res3.data);
                    if (res3.data.error) {
                      alert(res3.data.error);
                      window.location = Conf.frontendURL;
                    } else {
                      var response = res3.data;
                      document.getElementById("code").value =
                        response.patron_code;
                      document.getElementById("name").value =
                        response.first_name + " " + response.last_name;
                      document.getElementById("patform").submit();
                    }
                  });
              });
          } else {
            window.location = Conf.frontendURL;
          }
        });
    } else {
      window.location = Conf.frontendURL;
    }
  }
  render() {
    return (
      <React.Fragment>
        <form
          action="https://search.library.cmu.ac.th/patroninfo"
          name="patform"
          method="POST"
          target="_parent"
          id="patform"
        >
          <div>
            <input name="name" id="name" type="hidden" value="" readOnly />
          </div>
          <div>
            <input name="code" id="code" type="hidden" value="" readOnly />
          </div>
          <div>
            <input type="hidden" name="pat_submit" value="xxx" />
          </div>
        </form>
      </React.Fragment>
    );
  }
}
export default Auth;
